const mediaQuery = {
  mobile: 550,
  tablet: 850,
  laptop: 1024,
  desktop: 1200,
  big: 1600,
};

export default mediaQuery;
